<template>

  <svg class="icon" width="48" height="34" viewBox="0 0 48 34" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd"
          d="M8.34275 19.3498L17.7866 29.2462C18.6061 30.105 18.6061 31.4562 17.7866 32.315C16.911 33.2326 15.4464 33.2326 14.5708 32.315L1.46384 18.5801C0.644321 17.7213 0.644321 16.3701 1.46384 15.5113L3.06654 13.8318C3.0694 13.8288 3.07418 13.8288 3.07704 13.8318C3.0799 13.8348 3.08467 13.8348 3.08753 13.8318L14.6789 1.68498C15.5545 0.76742 17.0192 0.767418 17.8948 1.68498C18.7143 2.54378 18.7143 3.895 17.8948 4.75379L8.31089 14.7969H45.3232C46.5804 14.7969 47.5996 15.8161 47.5996 17.0734C47.5996 18.3306 46.5804 19.3498 45.3232 19.3498H8.34275Z"
          fill="#F06F44"/>
  </svg>

</template>

<script>
export default {
  name: 'IconArrowLeft'
}
</script>
